import React, { useState, useEffect, useCallback } from "react";
import { HotspotLocations } from "../../../util/hotspotData";
import Hotspot from "./Hotspot";
import useCustomizerStore from "../../../state/customizer";
import useTransitionStore from "../../../state/transitions";
import { isMobile, useMobileOrientation } from "react-device-detect";

const Hotspots = () => {
  const [isSelected, setIsSelected] = useState(false);
  const [modelString, setModelString] = useState("");
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const model = useCustomizerStore((s) => s.model);
  const selectedHotspot = useCustomizerStore((s) => s.selectedHotspot);
  const setSelectedHotspot = useCustomizerStore((s) => s.setSelectedHotspot);
  const setHotspotLocations = useCustomizerStore((s) => s.setHotspotLocations);
  const hotspotLocations = useCustomizerStore((s) => s.hotspotLocations);
  // const [hotspotLocations, setHotspotLocations] = useState(
  //   HotspotLocations(DisplayMode)
  // );
  const setCameraMoveToHotspot = useTransitionStore(
    (s) => s.setCameraMoveToHotspot
  );
  const setHotspotControls = useTransitionStore((s) => s.setHotspotControls);
  const setTempAzimuthAndPolarAngles = useTransitionStore(
    (s) => s.setTempAzimuthAndPolarAngles
  );
  const setAzimuthAndPolarAnglesNeedUpdate = useTransitionStore(
    (s) => s.setAzimuthAndPolarAnglesNeedUpdate
  );
  const setShowScrollContainer = useTransitionStore(
    (s) => s.setShowScrollContainer
  );
  const triggerResetAutoRotateDelta = useTransitionStore(
    (s) => s.triggerResetAutoRotateDelta
  );
  const ResetAutoRotateDelta = useTransitionStore(
    (s) => s.ResetAutoRotateDelta
  );
  const setSelectedDisclaimer = useCustomizerStore(
    (s) => s.setSelectedDisclaimer
  );
  const setHotspotZoomed = useTransitionStore((s) => s.setHotspotZoomed);

  const setFutureSelectedHotspotDescription = useCustomizerStore(
    (s) => s.setFutureSelectedHotspotDescription
  );
  const setFutureSelectedHotspotTitle = useCustomizerStore(
    (s) => s.setFutureSelectedHotspotTitle
  );
  const setDisclaimerOpen = useCustomizerStore((s) => s.setDisclaimerOpen);
  const filterHotspots = useCustomizerStore((s) => s.filterHotspots);
  const setFilterHotspots = useCustomizerStore((s) => s.setFilterHotspots);
  const setfutureSelectedDisclaimer = useCustomizerStore(
    (s) => s.setfutureSelectedDisclaimer
  );
  const setSuspensionMode = useTransitionStore((s) => s.setSuspensionMode);
  const SuspensionMode = useTransitionStore((s) => s.SuspensionMode);
  const setTriggerExitHotspot = useTransitionStore(
    (s) => s.setTriggerExitHotspot
  );
  const TriggerExitHotspot = useTransitionStore((s) => s.TriggerExitHotspot);
  const setOrbitMode = useTransitionStore((s) => s.setOrbitMode);

  const { isLandscape } = useMobileOrientation();

  useEffect(() => {
    setHotspotLocations(HotspotLocations(DisplayMode));
  }, []);

  useEffect(() => {
    handleModelChange();
  }, [model]);

  const handleModelChange = useCallback(() => {
    if (model == 0) setModelString("xle");
    if (model == 1) setModelString("limited");
    if (model == 2) setModelString("platinum");
  });

  const clearSelectedHotspot = useCallback(() => {
    const oldSelectedHotspot = hotspotLocations.filter(
      (Hotspot) => Hotspot.selected === true
    );
    oldSelectedHotspot.forEach((hotspot) => (hotspot.selected = false));

    if (filterHotspots) setFilterHotspots(false);
  });

  const handleClick = useCallback((e) => {
    triggerResetAutoRotateDelta(!ResetAutoRotateDelta);

    clearSelectedHotspot();
    setShowScrollContainer(false);

    hotspotLocations[e].selected = true;

    //* Transition camera to clicked on Hotspot if needed
    if (hotspotLocations[e].target) {
      if (isMobile) {
        if (isMobile && isLandscape && hotspotLocations[e].landscapeOffset) {
          setCameraMoveToHotspot({
            position: hotspotLocations[e].landscapeOffset,
            target: hotspotLocations[e].target,
          });
        } else {
          setCameraMoveToHotspot({
            position: hotspotLocations[e].mobileOffset,
            target: hotspotLocations[e].target,
          });
        }
      } else {
        setCameraMoveToHotspot({
          position: hotspotLocations[e].offset,
          target: hotspotLocations[e].target,
        });
      }

      setTempAzimuthAndPolarAngles({
        minAzimuthAngle: hotspotLocations[e].minAzimuthAngle,
        maxAzimuthAngle: hotspotLocations[e].maxAzimuthAngle,
        minPolarAngle: hotspotLocations[e].minPolarAngle,
        maxPolarAngle: hotspotLocations[e].maxPolarAngle,
      });

      setAzimuthAndPolarAnglesNeedUpdate(true);
      setHotspotControls(true);
      setHotspotZoomed(true);

      if (hotspotLocations[e].title == "Adaptive Variable Suspension") {
        setHotspotZoomed(false);
        setSuspensionMode(true);
        setAzimuthAndPolarAnglesNeedUpdate(false);
      }

      setFilterHotspots(true);
    }

    // * Exiting Suspension Mode Logic
    if (SuspensionMode) {
      setSuspensionMode(false);
      setTriggerExitHotspot(!TriggerExitHotspot);
    }
    //* Disclaimer
    if (hotspotLocations[e].disclaimer) {
      setfutureSelectedDisclaimer(hotspotLocations[e].disclaimer);
    } else {
      setfutureSelectedDisclaimer("");
    }
    setFutureSelectedHotspotDescription(hotspotLocations[e].body);
    setFutureSelectedHotspotTitle(hotspotLocations[e].title);
    setSelectedHotspot(hotspotLocations[e].id);
  });

  if (!hotspotLocations) return;
  return (
    <>
      {filterHotspots ? (
        hotspotLocations
          .filter((e) => e.selected === true)
          .map((e, i) => (
            <Hotspot
              e={e}
              key={"filtered hotspots" + i}
              switchSides={e.switchSides}
              offset={e.offset}
              position={e.position}
              id={e.id}
              cat={e.cat}
              selected={selectedHotspot === e.id}
              handleClick={handleClick}
            />
          ))
      ) : (
        <>
          {!filterHotspots &&
            hotspotLocations
              .filter((e) => e.cat.includes(modelString))
              .map((e, i) => (
                <Hotspot
                  e={e}
                  key={"hotspots" + i}
                  switchSides={e.switchSides}
                  offset={e.offset}
                  position={e.position}
                  id={e.id}
                  cat={e.cat}
                  selected={selectedHotspot === e.id}
                  handleClick={handleClick}
                />
              ))}
        </>
      )}
    </>
  );
};

export default React.memo(Hotspots);
